import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
	colors,
} from '@material-ui/core';

import ModalDialog from '../../../../../../components/ModalDialog/ModalDialog.js';
import PacketEditFailureDialogForm from './components/PacketEditFailureDialogForm';
import { GetFailurePacketDetails, SetFailurePacketDetails } from '../../../../actions/PacketActions';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const PacketEditFailureDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	// const roles = useSelector((state) => state.usersReducer.roles);
	const tableId = useSelector((state) => state.packetReducer.tableId);
	// const operatorProjects = useSelector((state) => state.usersReducer.operatorProjects);
	 const formState = useSelector((state) => state.packetReducer.formState);
	// const openAddEditUserDialogId = useSelector((state) => state.usersReducer.openAddEditUserDialogId);
	const userId = useSelector(state => state.session.user.id);

	const _onConfirmClick = () => {
		// if (formState.isValid) {
		dispatch(SetFailurePacketDetails(formState.values, userId));
		// }
	};

	const getData = useCallback(() => {
		dispatch(GetFailurePacketDetails(tableId, userId));
		//  dispatch(GetOperators());
	}, []);

	useEffect(() => {
		getData();
	}, [tableId]);

	return (
		<ModalDialog
			maxWidth="xl"
			onClose={onClose}
			open={open}
			title="Packet failure"
			confirmLabel="Save"
			onConfirmClicked={_onConfirmClick}
		>
			{/* onConfirmClicked={_onConfirmClick}> */}
			{/* <PacketEditFailureDialogForm isEdit={openAddEditUserDialogId} roles={roles} operators={operators} projects={operatorProjects} /> */}
			<PacketEditFailureDialogForm tableId={tableId} />
		</ModalDialog>
	);
};

// PacketEditFailureDialog.propTypes = {
//     author: PropTypes.object.isRequired,
//     className: PropTypes.string,
//     onApply: PropTypes.func,
//     onClose: PropTypes.func,
//     open: PropTypes.bool.isRequired,
// }

export default PacketEditFailureDialog;
